// Neutral skeleton only — real copy lives in the DB (admin panel) and arrives
// pre-embedded by the server as window.__LANDING__ (or via /api/landing-content as fallback).
export const LANDING_DEFAULTS = {
  hero: { badge: "", titleLine1: "", titleHighlight: "", subtitle: "", ctaText: "Ingresar", ctaNote: "" },
  trust: [],
  features: { eyebrow: "", title: "", cards: [] },
  howItWorks: { eyebrow: "", title: "", steps: [] },
  whyFree: { eyebrow: "", title: "", paragraph: "", bullets: [], priceBig: "", priceSub: "", priceParagraph: "", priceCta: "Ingresar" },
  finalCta: { title: "", paragraph: "", ctaText: "Ingresar" },
  faq: { eyebrow: "", title: "", items: [] },
};
